import FormHelperText from '@mui/material/FormHelperText';
import React, {memo} from 'react';

const TextError = (props: any): any => {
    return (
        <FormHelperText error id="standard-weight-helper-text-email-login" className={props.className}>
            {props.children}
        </FormHelperText>
    );
};

export default memo(TextError);
